import { getStartDate, getEndDate, parseJavaLocalDateTimeArray } from "utils";

import {
  UPLOAD_NAME,
  UPLOADED_BY_ALL_OPTION,
  UPLOAD_NAME_TONE_PALETTE,
} from "./constants";

export const getUploadNameTone = (value) => {
  if (!value) return UPLOAD_NAME_TONE_PALETTE[0];

  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }

  return UPLOAD_NAME_TONE_PALETTE[
    Math.abs(hash) % UPLOAD_NAME_TONE_PALETTE.length
  ];
};

// Normalizes a raw history API file item into the shape the UI expects.
export const mapHistoryFile = (file = {}) => ({
  requestId: file?.fileEngineId,
  uploadName: file?.fileType ?? "-",
  definitionVersion: file?.definitionVersion ?? 1.0,
  fileName: file?.fileName ?? "-",
  uploadedBy: file?.uploadedBy ?? "-",
  uploadedAt: parseJavaLocalDateTimeArray(file?.createdAt),
  totalRows: file?.totalRows ?? 0,
  passedRows: file?.successfulRecords ?? 0,
  failedRows: file?.failedRecordsCount ?? 0,
  skippedRows: file?.skippedRecords ?? 0,
  warningRows: file?.warningRecords ?? 0,
  status: file?.status,
  errorMessage: file?.errorMessage,
});

// Maps the filter form values to the history API's query params.
export const buildFilterRequestPayload = (formValues = {}) => {
  const { search, uploadName, uploadedBy, uploadedFrom, uploadedTo } =
    formValues;

  return {
    fileName: search?.trim() || undefined,
    fileType: uploadName === UPLOAD_NAME.ALL ? undefined : uploadName,
    uploadedBy: uploadedBy === UPLOADED_BY_ALL_OPTION ? undefined : uploadedBy,
    startDate: uploadedFrom ? getStartDate(uploadedFrom).valueOf() : undefined,
    endDate: uploadedTo ? getEndDate(uploadedTo).valueOf() : undefined,
  };
};
